/** Lowercased, accent-stripped form used for diacritic-insensitive matching. */
export function normalizeSearchText(value: string): string {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}

/** `value` contains the already-normalised `needle` (null/empty never matches). */
export function includesNormalized(value: string | null | undefined, needle: string): boolean {
  return !!value && normalizeSearchText(value).includes(needle);
}
